//IMGS START
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
//drinks
import bar1_360 from "../../assets/images/gallery/360/home/bar/1.webp";
import bar1_600 from "../../assets/images/gallery/600/home/bar/1.webp";
import bar1_1366 from "../../assets/images/gallery/1366/home/bar/1.webp";
import bar2_360 from "../../assets/images/gallery/360/home/bar/2.webp";
import bar2_600 from "../../assets/images/gallery/600/home/bar/2.webp";
import bar2_1366 from "../../assets/images/gallery/1366/home/bar/2.webp";

import bar5_360 from "../../assets/images/gallery/360/home/bar/5.webp";
import bar5_600 from "../../assets/images/gallery/600/home/bar/5.webp";
import bar5_1366 from "../../assets/images/gallery/1366/home/bar/5.webp";

import bar7_360 from "../../assets/images/gallery/360/home/bar/7.webp";
import bar7_600 from "../../assets/images/gallery/600/home/bar/7.webp";
import bar7_1366 from "../../assets/images/gallery/1366/home/bar/7.webp";
import bar8_360 from "../../assets/images/gallery/360/home/bar/8.webp";
import bar8_600 from "../../assets/images/gallery/600/home/bar/8.webp";
import bar8_1366 from "../../assets/images/gallery/1366/home/bar/8.webp";
import bar9_360 from "../../assets/images/gallery/360/home/bar/9.webp";
import bar9_600 from "../../assets/images/gallery/600/home/bar/9.webp";
import bar9_1366 from "../../assets/images/gallery/1366/home/bar/9.webp";
import bar10_360 from "../../assets/images/gallery/360/home/bar/10.webp";
import bar10_600 from "../../assets/images/gallery/600/home/bar/10.webp";
import bar10_1366 from "../../assets/images/gallery/1366/home/bar/10.webp";

import bar17_360 from "../../assets/images/gallery/360/home/bar/17.webp";
import bar17_600 from "../../assets/images/gallery/600/home/bar/17.webp";
import bar17_1366 from "../../assets/images/gallery/1366/home/bar/17.webp";
import bar18_360 from "../../assets/images/gallery/360/home/bar/18.webp";
import bar18_600 from "../../assets/images/gallery/600/home/bar/18.webp";
import bar18_1366 from "../../assets/images/gallery/1366/home/bar/18.webp";
//gallery

//IMGS END
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, Thumbs, FreeMode } from "swiper";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import "swiper/css/thumbs";

import { useInView } from "react-intersection-observer";

import elegant1_360 from "../../assets/images/gallery/360/2025nyar/elegant/2-72dpi.webp";
import elegant1_600 from "../../assets/images/gallery/600/2025nyar/elegant/2-72dpi.webp";
import elegant1_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/2-72dpi.webp";
import elegant2_360 from "../../assets/images/gallery/360/2025nyar/elegant/4H9A8355.webp";
import elegant2_600 from "../../assets/images/gallery/600/2025nyar/elegant/4H9A8355.webp";
import elegant2_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/4H9A8355.webp";
import elegant3_360 from "../../assets/images/gallery/360/2025nyar/elegant/4H9A8384.webp";
import elegant3_600 from "../../assets/images/gallery/600/2025nyar/elegant/4H9A8384.webp";
import elegant3_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/4H9A8384.webp";
import elegant4_360 from "../../assets/images/gallery/360/2025nyar/elegant/4H9A8549.webp";
import elegant4_600 from "../../assets/images/gallery/600/2025nyar/elegant/4H9A8549.webp";
import elegant4_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/4H9A8549.webp";
import elegant5_360 from "../../assets/images/gallery/360/2025nyar/elegant/4H9A8582.webp";
import elegant5_600 from "../../assets/images/gallery/600/2025nyar/elegant/4H9A8582.webp";
import elegant5_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/4H9A8582.webp";
import elegant6_360 from "../../assets/images/gallery/360/2025nyar/elegant/4H9A8597.webp";
import elegant6_600 from "../../assets/images/gallery/600/2025nyar/elegant/4H9A8597.webp";
import elegant6_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/4H9A8597.webp";
import elegant7_360 from "../../assets/images/gallery/360/2025nyar/elegant/4H9A8603_no_gorbe.webp";
import elegant7_600 from "../../assets/images/gallery/600/2025nyar/elegant/4H9A8603_no_gorbe.webp";
import elegant7_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/4H9A8603_no_gorbe.webp";
import elegant8_360 from "../../assets/images/gallery/360/2025nyar/elegant/186A9708-31.webp";
import elegant8_600 from "../../assets/images/gallery/600/2025nyar/elegant/186A9708-31.webp";
import elegant8_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/186A9708-31.webp";
import elegant9_360 from "../../assets/images/gallery/360/2025nyar/elegant/20220107-DSC_2987.webp";
import elegant9_600 from "../../assets/images/gallery/600/2025nyar/elegant/20220107-DSC_2987.webp";
import elegant9_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/20220107-DSC_2987.webp";
import elegant10_360 from "../../assets/images/gallery/360/2025nyar/elegant/20220505-DSC_3404-Edit.webp";
import elegant10_600 from "../../assets/images/gallery/600/2025nyar/elegant/20220505-DSC_3404-Edit.webp";
import elegant10_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/20220505-DSC_3404-Edit.webp";
import elegant11_360 from "../../assets/images/gallery/360/2025nyar/elegant/citadella-belso-21.webp";
import elegant11_600 from "../../assets/images/gallery/600/2025nyar/elegant/citadella-belso-21.webp";
import elegant11_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/citadella-belso-21.webp";
import elegant12_360 from "../../assets/images/gallery/360/2025nyar/elegant/DA201215.webp";
import elegant12_600 from "../../assets/images/gallery/600/2025nyar/elegant/DA201215.webp";
import elegant12_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DA201215.webp";
import elegant13_360 from "../../assets/images/gallery/360/2025nyar/elegant/DA203410.webp";
import elegant13_600 from "../../assets/images/gallery/600/2025nyar/elegant/DA203410.webp";
import elegant13_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DA203410.webp";
import elegant14_360 from "../../assets/images/gallery/360/2025nyar/elegant/DA203749_ratio16-9.webp";
import elegant14_600 from "../../assets/images/gallery/600/2025nyar/elegant/DA203749_ratio16-9.webp";
import elegant14_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DA203749_ratio16-9.webp";
import elegant15_360 from "../../assets/images/gallery/360/2025nyar/elegant/DA209444_removed_rope.webp";
import elegant15_600 from "../../assets/images/gallery/600/2025nyar/elegant/DA209444_removed_rope.webp";
import elegant15_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DA209444_removed_rope.webp";
import elegant16_360 from "../../assets/images/gallery/360/2025nyar/elegant/DA209461-2.webp";
import elegant16_600 from "../../assets/images/gallery/600/2025nyar/elegant/DA209461-2.webp";
import elegant16_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DA209461-2.webp";
import elegant17_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC01057.webp";
import elegant17_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC01057.webp";
import elegant17_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC01057.webp";
import elegant18_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC01068.webp";
import elegant18_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC01068.webp";
import elegant18_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC01068.webp";
import elegant19_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC01071.webp";
import elegant19_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC01071.webp";
import elegant19_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC01071.webp";
import elegant20_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC01097.webp";
import elegant20_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC01097.webp";
import elegant20_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC01097.webp";

import elegant21_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC01109.webp";
import elegant22_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC01135.webp";
import elegant23_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC01242.webp";
import elegant24_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC01246.webp";
import elegant25_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC01259.webp";
import elegant26_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC01279.webp";
import elegant27_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC01463.webp";
import elegant28_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC01613.webp";
import elegant29_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC01627.webp";
import elegant30_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC01683.webp";
import elegant31_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC01771.webp";
import elegant32_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC01843.webp";
import elegant33_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC01883.webp";
import elegant34_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC01962_rotated_2560px.webp";
import elegant35_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC02001.webp";
import elegant36_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC06097.webp";
import elegant37_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC07837.webp";
import elegant38_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC07852.webp";
import elegant39_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC07883.webp";
import elegant40_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC07900.webp";
import elegant41_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC07935.webp";
import elegant42_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC07943.webp";
import elegant43_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC07995.webp";
import elegant44_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC08025.webp";
import elegant45_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC08050.webp";
import elegant46_360 from "../../assets/images/gallery/360/2025nyar/elegant/DSC08056.webp";
import elegant47_360 from "../../assets/images/gallery/360/2025nyar/elegant/DunaCruises-0710_BP-6095.webp";
import elegant48_360 from "../../assets/images/gallery/360/2025nyar/elegant/DunaCruises-0710_BP-6104.webp";
import elegant49_360 from "../../assets/images/gallery/360/2025nyar/elegant/DunaCruises-0710_BP-6194.webp";
import elegant50_360 from "../../assets/images/gallery/360/2025nyar/elegant/DunaCruises-0710_BP-6380.webp";
import elegant51_360 from "../../assets/images/gallery/360/2025nyar/elegant/DunaCruises-0710_BP-6518.webp";
import elegant52_360 from "../../assets/images/gallery/360/2025nyar/elegant/DunaCruises-0710_BP-6544.webp";
import elegant53_360 from "../../assets/images/gallery/360/2025nyar/elegant/DunaCruises-BP-1353.webp";
import elegant54_360 from "../../assets/images/gallery/360/2025nyar/elegant/DunaCruises-BP-1592.webp";
import elegant55_360 from "../../assets/images/gallery/360/2025nyar/elegant/DunaCruises-BP-1607.webp";
import elegant56_360 from "../../assets/images/gallery/360/2025nyar/elegant/DunaCruises-BP-1692.webp";
import elegant57_360 from "../../assets/images/gallery/360/2025nyar/elegant/hajo majus-04723.webp";
import elegant58_360 from "../../assets/images/gallery/360/2025nyar/elegant/hajo majus-04754.webp";
import elegant59_360 from "../../assets/images/gallery/360/2025nyar/elegant/hajo majus-04777.webp";
import elegant60_360 from "../../assets/images/gallery/360/2025nyar/elegant/hajo majus-04883.webp";
import elegant61_360 from "../../assets/images/gallery/360/2025nyar/elegant/MGR_IMAGES_2023_DC_1014_028-2.webp";
import elegant62_360 from "../../assets/images/gallery/360/2025nyar/elegant/MGR_IMAGES_2023_DC_1014_067_added_sky&clouds_mod_1920x1080_72dpi.webp";
import elegant63_360 from "../../assets/images/gallery/360/2025nyar/elegant/mod_cold.webp";

import elegant21_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC01109.webp";
import elegant22_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC01135.webp";
import elegant23_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC01242.webp";
import elegant24_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC01246.webp";
import elegant25_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC01259.webp";
import elegant26_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC01279.webp";
import elegant27_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC01463.webp";
import elegant28_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC01613.webp";
import elegant29_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC01627.webp";
import elegant30_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC01683.webp";
import elegant31_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC01771.webp";
import elegant32_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC01843.webp";
import elegant33_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC01883.webp";
import elegant34_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC01962_rotated_2560px.webp";
import elegant35_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC02001.webp";
import elegant36_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC06097.webp";
import elegant37_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC07837.webp";
import elegant38_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC07852.webp";
import elegant39_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC07883.webp";
import elegant40_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC07900.webp";
import elegant41_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC07935.webp";
import elegant42_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC07943.webp";
import elegant43_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC07995.webp";
import elegant44_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC08025.webp";
import elegant45_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC08050.webp";
import elegant46_600 from "../../assets/images/gallery/600/2025nyar/elegant/DSC08056.webp";
import elegant47_600 from "../../assets/images/gallery/600/2025nyar/elegant/DunaCruises-0710_BP-6095.webp";
import elegant48_600 from "../../assets/images/gallery/600/2025nyar/elegant/DunaCruises-0710_BP-6104.webp";
import elegant49_600 from "../../assets/images/gallery/600/2025nyar/elegant/DunaCruises-0710_BP-6194.webp";
import elegant50_600 from "../../assets/images/gallery/600/2025nyar/elegant/DunaCruises-0710_BP-6380.webp";
import elegant51_600 from "../../assets/images/gallery/600/2025nyar/elegant/DunaCruises-0710_BP-6518.webp";
import elegant52_600 from "../../assets/images/gallery/600/2025nyar/elegant/DunaCruises-0710_BP-6544.webp";
import elegant53_600 from "../../assets/images/gallery/600/2025nyar/elegant/DunaCruises-BP-1353.webp";
import elegant54_600 from "../../assets/images/gallery/600/2025nyar/elegant/DunaCruises-BP-1592.webp";
import elegant55_600 from "../../assets/images/gallery/600/2025nyar/elegant/DunaCruises-BP-1607.webp";
import elegant56_600 from "../../assets/images/gallery/600/2025nyar/elegant/DunaCruises-BP-1692.webp";
import elegant57_600 from "../../assets/images/gallery/600/2025nyar/elegant/hajo majus-04723.webp";
import elegant58_600 from "../../assets/images/gallery/600/2025nyar/elegant/hajo majus-04754.webp";
import elegant59_600 from "../../assets/images/gallery/600/2025nyar/elegant/hajo majus-04777.webp";
import elegant60_600 from "../../assets/images/gallery/600/2025nyar/elegant/hajo majus-04883.webp";
import elegant61_600 from "../../assets/images/gallery/600/2025nyar/elegant/MGR_IMAGES_2023_DC_1014_028-2.webp";
import elegant62_600 from "../../assets/images/gallery/600/2025nyar/elegant/MGR_IMAGES_2023_DC_1014_067_added_sky&clouds_mod_1920x1080_72dpi.webp";
import elegant63_600 from "../../assets/images/gallery/600/2025nyar/elegant/mod_cold.webp";

import elegant21_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC01109.webp";
import elegant22_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC01135.webp";
import elegant23_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC01242.webp";
import elegant24_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC01246.webp";
import elegant25_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC01259.webp";
import elegant26_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC01279.webp";
import elegant27_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC01463.webp";
import elegant28_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC01613.webp";
import elegant29_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC01627.webp";
import elegant30_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC01683.webp";
import elegant31_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC01771.webp";
import elegant32_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC01843.webp";
import elegant33_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC01883.webp";
import elegant34_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC01962_rotated_2560px.webp";
import elegant35_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC02001.webp";
import elegant36_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC06097.webp";
import elegant37_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC07837.webp";
import elegant38_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC07852.webp";
import elegant39_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC07883.webp";
import elegant40_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC07900.webp";
import elegant41_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC07935.webp";
import elegant42_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC07943.webp";
import elegant43_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC07995.webp";
import elegant44_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC08025.webp";
import elegant45_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC08050.webp";
import elegant46_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DSC08056.webp";
import elegant47_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DunaCruises-0710_BP-6095.webp";
import elegant48_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DunaCruises-0710_BP-6104.webp";
import elegant49_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DunaCruises-0710_BP-6194.webp";
import elegant50_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DunaCruises-0710_BP-6380.webp";
import elegant51_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DunaCruises-0710_BP-6518.webp";
import elegant52_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DunaCruises-0710_BP-6544.webp";
import elegant53_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DunaCruises-BP-1353.webp";
import elegant54_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DunaCruises-BP-1592.webp";
import elegant55_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DunaCruises-BP-1607.webp";
import elegant56_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/DunaCruises-BP-1692.webp";
import elegant57_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/hajo majus-04723.webp";
import elegant58_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/hajo majus-04754.webp";
import elegant59_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/hajo majus-04777.webp";
import elegant60_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/hajo majus-04883.webp";
import elegant61_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/MGR_IMAGES_2023_DC_1014_028-2.webp";
import elegant62_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/MGR_IMAGES_2023_DC_1014_067_added_sky&clouds_mod_1920x1080_72dpi.webp";
import elegant63_1366 from "../../assets/images/gallery/1366/2025nyar/elegant/mod_cold.webp";

import historical1_360 from "../../assets/images/gallery/360/2025nyar/historical/4H9A8029.webp";
import historical2_360 from "../../assets/images/gallery/360/2025nyar/historical/4H9A8450 (2).webp";
import historical3_360 from "../../assets/images/gallery/360/2025nyar/historical/2023-kisfaludy-fedelzet.webp";
import historical4_360 from "../../assets/images/gallery/360/2025nyar/historical/2023-kisfaludy-hajo (1).webp";
import historical5_360 from "../../assets/images/gallery/360/2025nyar/historical/2023-kisfaludy-hajo (1)-2.webp";
import historical6_360 from "../../assets/images/gallery/360/2025nyar/historical/DA200398.webp";
import historical7_360 from "../../assets/images/gallery/360/2025nyar/historical/DA200400.webp";
import historical8_360 from "../../assets/images/gallery/360/2025nyar/historical/DA200440.webp";
import historical9_360 from "../../assets/images/gallery/360/2025nyar/historical/DA200483.webp";
import historical10_360 from "../../assets/images/gallery/360/2025nyar/historical/DA200507.webp";
import historical11_360 from "../../assets/images/gallery/360/2025nyar/historical/DA200525.webp";
import historical12_360 from "../../assets/images/gallery/360/2025nyar/historical/DA200534.webp";
import historical13_360 from "../../assets/images/gallery/360/2025nyar/historical/DA200993.webp";
import historical14_360 from "../../assets/images/gallery/360/2025nyar/historical/DA201026.webp";
import historical15_360 from "../../assets/images/gallery/360/2025nyar/historical/DA201067.webp";
import historical16_360 from "../../assets/images/gallery/360/2025nyar/historical/DA201205.webp";
import historical17_360 from "../../assets/images/gallery/360/2025nyar/historical/DA201349.webp";
import historical18_360 from "../../assets/images/gallery/360/2025nyar/historical/DA201418.webp";
import historical19_360 from "../../assets/images/gallery/360/2025nyar/historical/DA201429.webp";
import historical20_360 from "../../assets/images/gallery/360/2025nyar/historical/DA201436.webp";
import historical21_360 from "../../assets/images/gallery/360/2025nyar/historical/DA201454.webp";
import historical22_360 from "../../assets/images/gallery/360/2025nyar/historical/DSC04508.webp";
import historical23_360 from "../../assets/images/gallery/360/2025nyar/historical/DSC04594.webp";
import historical24_360 from "../../assets/images/gallery/360/2025nyar/historical/DSC04607.webp";
import historical25_360 from "../../assets/images/gallery/360/2025nyar/historical/DSC04610.webp";
import historical26_360 from "../../assets/images/gallery/360/2025nyar/historical/DSC04669-Enhanced-NR.webp";
import historical27_360 from "../../assets/images/gallery/360/2025nyar/historical/DSC06065.webp";
import historical28_360 from "../../assets/images/gallery/360/2025nyar/historical/DSC06095.webp";
import historical29_360 from "../../assets/images/gallery/360/2025nyar/historical/DSC06168.webp";
import historical30_360 from "../../assets/images/gallery/360/2025nyar/historical/DSC06464.webp";
import historical31_360 from "../../assets/images/gallery/360/2025nyar/historical/DunaCruises-0710_BP-5145.webp";
import historical32_360 from "../../assets/images/gallery/360/2025nyar/historical/DunaCruises-0710_BP-5476.webp";
import historical33_360 from "../../assets/images/gallery/360/2025nyar/historical/DunaCruises-0710_BP-5735.webp";
import historical34_360 from "../../assets/images/gallery/360/2025nyar/historical/DunaCruises-0710_BP-5839.webp";
import historical35_360 from "../../assets/images/gallery/360/2025nyar/historical/DunaCruises-BP-2-5.webp";
import historical36_360 from "../../assets/images/gallery/360/2025nyar/historical/DunaCruises-BP-1361.webp";
import historical37_360 from "../../assets/images/gallery/360/2025nyar/historical/DunaCruises-BP-1367.webp";
import historical38_360 from "../../assets/images/gallery/360/2025nyar/historical/DunaCruises-BP-1431.webp";
import historical39_360 from "../../assets/images/gallery/360/2025nyar/historical/DunaCruises-BP-1655_mod_water.webp";
import historical40_360 from "../../assets/images/gallery/360/2025nyar/historical/hajo majus-04703.webp";
import historical41_360 from "../../assets/images/gallery/360/2025nyar/historical/hajooo--5.webp";
import historical42_360 from "../../assets/images/gallery/360/2025nyar/historical/inst4 (1).webp";
import historical43_360 from "../../assets/images/gallery/360/2025nyar/historical/majus17-208405.webp";
import historical44_360 from "../../assets/images/gallery/360/2025nyar/historical/majus17-208412.webp";
import historical45_360 from "../../assets/images/gallery/360/2025nyar/historical/majus17-208449.webp";
import historical46_360 from "../../assets/images/gallery/360/2025nyar/historical/majus17-208462.webp";
import historical47_360 from "../../assets/images/gallery/360/2025nyar/historical/majus17-208489.webp";
import historical48_360 from "../../assets/images/gallery/360/2025nyar/historical/majus17-208495.webp";
import historical49_360 from "../../assets/images/gallery/360/2025nyar/historical/majus17-208543.webp";
import historical50_360 from "../../assets/images/gallery/360/2025nyar/historical/majus17-208551.webp";

import historical1_600 from "../../assets/images/gallery/600/2025nyar/historical/4H9A8029.webp";
import historical2_600 from "../../assets/images/gallery/600/2025nyar/historical/4H9A8450 (2).webp";
import historical3_600 from "../../assets/images/gallery/600/2025nyar/historical/2023-kisfaludy-fedelzet.webp";
import historical4_600 from "../../assets/images/gallery/600/2025nyar/historical/2023-kisfaludy-hajo (1).webp";
import historical5_600 from "../../assets/images/gallery/600/2025nyar/historical/2023-kisfaludy-hajo (1)-2.webp";
import historical6_600 from "../../assets/images/gallery/600/2025nyar/historical/DA200398.webp";
import historical7_600 from "../../assets/images/gallery/600/2025nyar/historical/DA200400.webp";
import historical8_600 from "../../assets/images/gallery/600/2025nyar/historical/DA200440.webp";
import historical9_600 from "../../assets/images/gallery/600/2025nyar/historical/DA200483.webp";
import historical10_600 from "../../assets/images/gallery/600/2025nyar/historical/DA200507.webp";
import historical11_600 from "../../assets/images/gallery/600/2025nyar/historical/DA200525.webp";
import historical12_600 from "../../assets/images/gallery/600/2025nyar/historical/DA200534.webp";
import historical13_600 from "../../assets/images/gallery/600/2025nyar/historical/DA200993.webp";
import historical14_600 from "../../assets/images/gallery/600/2025nyar/historical/DA201026.webp";
import historical15_600 from "../../assets/images/gallery/600/2025nyar/historical/DA201067.webp";
import historical16_600 from "../../assets/images/gallery/600/2025nyar/historical/DA201205.webp";
import historical17_600 from "../../assets/images/gallery/600/2025nyar/historical/DA201349.webp";
import historical18_600 from "../../assets/images/gallery/600/2025nyar/historical/DA201418.webp";
import historical19_600 from "../../assets/images/gallery/600/2025nyar/historical/DA201429.webp";
import historical20_600 from "../../assets/images/gallery/600/2025nyar/historical/DA201436.webp";
import historical21_600 from "../../assets/images/gallery/600/2025nyar/historical/DA201454.webp";
import historical22_600 from "../../assets/images/gallery/600/2025nyar/historical/DSC04508.webp";
import historical23_600 from "../../assets/images/gallery/600/2025nyar/historical/DSC04594.webp";
import historical24_600 from "../../assets/images/gallery/600/2025nyar/historical/DSC04607.webp";
import historical25_600 from "../../assets/images/gallery/600/2025nyar/historical/DSC04610.webp";
import historical26_600 from "../../assets/images/gallery/600/2025nyar/historical/DSC04669-Enhanced-NR.webp";
import historical27_600 from "../../assets/images/gallery/600/2025nyar/historical/DSC06065.webp";
import historical28_600 from "../../assets/images/gallery/600/2025nyar/historical/DSC06095.webp";
import historical29_600 from "../../assets/images/gallery/600/2025nyar/historical/DSC06168.webp";
import historical30_600 from "../../assets/images/gallery/600/2025nyar/historical/DSC06464.webp";
import historical31_600 from "../../assets/images/gallery/600/2025nyar/historical/DunaCruises-0710_BP-5145.webp";
import historical32_600 from "../../assets/images/gallery/600/2025nyar/historical/DunaCruises-0710_BP-5476.webp";
import historical33_600 from "../../assets/images/gallery/600/2025nyar/historical/DunaCruises-0710_BP-5735.webp";
import historical34_600 from "../../assets/images/gallery/600/2025nyar/historical/DunaCruises-0710_BP-5839.webp";
import historical35_600 from "../../assets/images/gallery/600/2025nyar/historical/DunaCruises-BP-2-5.webp";
import historical36_600 from "../../assets/images/gallery/600/2025nyar/historical/DunaCruises-BP-1361.webp";
import historical37_600 from "../../assets/images/gallery/600/2025nyar/historical/DunaCruises-BP-1367.webp";
import historical38_600 from "../../assets/images/gallery/600/2025nyar/historical/DunaCruises-BP-1431.webp";
import historical39_600 from "../../assets/images/gallery/600/2025nyar/historical/DunaCruises-BP-1655_mod_water.webp";
import historical40_600 from "../../assets/images/gallery/600/2025nyar/historical/hajo majus-04703.webp";
import historical41_600 from "../../assets/images/gallery/600/2025nyar/historical/hajooo--5.webp";
import historical42_600 from "../../assets/images/gallery/600/2025nyar/historical/inst4 (1).webp";
import historical43_600 from "../../assets/images/gallery/600/2025nyar/historical/majus17-208405.webp";
import historical44_600 from "../../assets/images/gallery/600/2025nyar/historical/majus17-208412.webp";
import historical45_600 from "../../assets/images/gallery/600/2025nyar/historical/majus17-208449.webp";
import historical46_600 from "../../assets/images/gallery/600/2025nyar/historical/majus17-208462.webp";
import historical47_600 from "../../assets/images/gallery/600/2025nyar/historical/majus17-208489.webp";
import historical48_600 from "../../assets/images/gallery/600/2025nyar/historical/majus17-208495.webp";
import historical49_600 from "../../assets/images/gallery/600/2025nyar/historical/majus17-208543.webp";
import historical50_600 from "../../assets/images/gallery/600/2025nyar/historical/majus17-208551.webp";

import historical1_1366 from "../../assets/images/gallery/1366/2025nyar/historical/4H9A8029.webp";
import historical2_1366 from "../../assets/images/gallery/1366/2025nyar/historical/4H9A8450 (2).webp";
import historical3_1366 from "../../assets/images/gallery/1366/2025nyar/historical/2023-kisfaludy-fedelzet.webp";
import historical4_1366 from "../../assets/images/gallery/1366/2025nyar/historical/2023-kisfaludy-hajo (1).webp";
import historical5_1366 from "../../assets/images/gallery/1366/2025nyar/historical/2023-kisfaludy-hajo (1)-2.webp";
import historical6_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DA200398.webp";
import historical7_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DA200400.webp";
import historical8_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DA200440.webp";
import historical9_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DA200483.webp";
import historical10_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DA200507.webp";
import historical11_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DA200525.webp";
import historical12_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DA200534.webp";
import historical13_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DA200993.webp";
import historical14_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DA201026.webp";
import historical15_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DA201067.webp";
import historical16_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DA201205.webp";
import historical17_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DA201349.webp";
import historical18_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DA201418.webp";
import historical19_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DA201429.webp";
import historical20_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DA201436.webp";
import historical21_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DA201454.webp";
import historical22_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DSC04508.webp";
import historical23_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DSC04594.webp";
import historical24_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DSC04607.webp";
import historical25_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DSC04610.webp";
import historical26_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DSC04669-Enhanced-NR.webp";
import historical27_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DSC06065.webp";
import historical28_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DSC06095.webp";
import historical29_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DSC06168.webp";
import historical30_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DSC06464.webp";
import historical31_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DunaCruises-0710_BP-5145.webp";
import historical32_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DunaCruises-0710_BP-5476.webp";
import historical33_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DunaCruises-0710_BP-5735.webp";
import historical34_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DunaCruises-0710_BP-5839.webp";
import historical35_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DunaCruises-BP-2-5.webp";
import historical36_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DunaCruises-BP-1361.webp";
import historical37_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DunaCruises-BP-1367.webp";
import historical38_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DunaCruises-BP-1431.webp";
import historical39_1366 from "../../assets/images/gallery/1366/2025nyar/historical/DunaCruises-BP-1655_mod_water.webp";
import historical40_1366 from "../../assets/images/gallery/1366/2025nyar/historical/hajo majus-04703.webp";
import historical41_1366 from "../../assets/images/gallery/1366/2025nyar/historical/hajooo--5.webp";
import historical42_1366 from "../../assets/images/gallery/1366/2025nyar/historical/inst4 (1).webp";
import historical43_1366 from "../../assets/images/gallery/1366/2025nyar/historical/majus17-208405.webp";
import historical44_1366 from "../../assets/images/gallery/1366/2025nyar/historical/majus17-208412.webp";
import historical45_1366 from "../../assets/images/gallery/1366/2025nyar/historical/majus17-208449.webp";
import historical46_1366 from "../../assets/images/gallery/1366/2025nyar/historical/majus17-208462.webp";
import historical47_1366 from "../../assets/images/gallery/1366/2025nyar/historical/majus17-208489.webp";
import historical48_1366 from "../../assets/images/gallery/1366/2025nyar/historical/majus17-208495.webp";
import historical49_1366 from "../../assets/images/gallery/1366/2025nyar/historical/majus17-208543.webp";
import historical50_1366 from "../../assets/images/gallery/1366/2025nyar/historical/majus17-208551.webp";

import historical51_360 from "../../assets/images/gallery/360/2025nyar/historical/juni1-209102[colorbalanced].webp";
import historical51_600 from "../../assets/images/gallery/600/2025nyar/historical/juni1-209102[colorbalanced].webp";
import historical51_1366 from "../../assets/images/gallery/1366/2025nyar/historical/juni1-209102[colorbalanced].webp";
import historical52_360 from "../../assets/images/gallery/360/2025nyar/historical/juni1-209191[colorbalanced].webp";
import historical52_600 from "../../assets/images/gallery/600/2025nyar/historical/juni1-209191[colorbalanced].webp";
import historical52_1366 from "../../assets/images/gallery/1366/2025nyar/historical/juni1-209191[colorbalanced].webp";

import nyar1_360 from "../../assets/images/gallery/360/2025nyar/majus31-07159[colorbalanced].webp";
import nyar2_360 from "../../assets/images/gallery/360/2025nyar/majus31-07002[colorbalanced].webp";
import nyar3_360 from "../../assets/images/gallery/360/2025nyar/majus31-07238[colorbalanced].webp";
import nyar4_360 from "../../assets/images/gallery/360/2025nyar/majus31-07423[colorbalanced].webp";
import nyar5_360 from "../../assets/images/gallery/360/2025nyar/majus31-07441[colorbalanced].webp";
import nyar6_360 from "../../assets/images/gallery/360/2025nyar/majus31-07727[colorbalanced].webp";
import nyar7_360 from "../../assets/images/gallery/360/2025nyar/juni1-209091[colorbalanced].webp";
import nyar8_360 from "../../assets/images/gallery/360/2025nyar/juni1-209182[colorbalanced].webp";
import nyar9_360 from "../../assets/images/gallery/360/2025nyar/juni1-209523[colorbalanced].webp";
import nyar10_360 from "../../assets/images/gallery/360/2025nyar/juni1-209564[colorbalanced].webp";
import nyar11_360 from "../../assets/images/gallery/360/2025nyar/juni1-209407[colorbalanced].webp";
import nyar12_360 from "../../assets/images/gallery/360/2025nyar/juni1-209385[colorbalanced].webp";
import nyar13_360 from "../../assets/images/gallery/360/2025nyar/juni1-209228[colorbalanced].webp";
import nyar14_360 from "../../assets/images/gallery/360/2025nyar/juni1-209106[colorbalanced].webp";

import nyar15_360 from "../../assets/images/gallery/360/2025nyar/hajofotok-200116[colorbalanced].webp";
import nyar16_360 from "../../assets/images/gallery/360/2025nyar/hajofotok-200141[colorbalanced].webp";
import nyar17_360 from "../../assets/images/gallery/360/2025nyar/hajofotok-200150[colorbalanced].webp";
import nyar18_360 from "../../assets/images/gallery/360/2025nyar/hajofotok-200261[colorbalanced].webp";
import nyar19_360 from "../../assets/images/gallery/360/2025nyar/hajofotok-200313[colorbalanced].webp";
import nyar20_360 from "../../assets/images/gallery/360/2025nyar/hajofotok-200442[colorbalanced].webp";
import nyar21_360 from "../../assets/images/gallery/360/2025nyar/hajofotok-209896[colorbalanced].webp";
import nyar22_360 from "../../assets/images/gallery/360/2025nyar/hajofotok-209901[colorbalanced].webp";

import nyar1_600 from "../../assets/images/gallery/600/2025nyar/majus31-07159[colorbalanced].webp";
import nyar2_600 from "../../assets/images/gallery/600/2025nyar/majus31-07002[colorbalanced].webp";
import nyar3_600 from "../../assets/images/gallery/600/2025nyar/majus31-07238[colorbalanced].webp";
import nyar4_600 from "../../assets/images/gallery/600/2025nyar/majus31-07423[colorbalanced].webp";
import nyar5_600 from "../../assets/images/gallery/600/2025nyar/majus31-07441[colorbalanced].webp";
import nyar6_600 from "../../assets/images/gallery/600/2025nyar/majus31-07727[colorbalanced].webp";
import nyar7_600 from "../../assets/images/gallery/600/2025nyar/juni1-209091[colorbalanced].webp";
import nyar8_600 from "../../assets/images/gallery/600/2025nyar/juni1-209182[colorbalanced].webp";
import nyar9_600 from "../../assets/images/gallery/600/2025nyar/juni1-209523[colorbalanced].webp";
import nyar10_600 from "../../assets/images/gallery/600/2025nyar/juni1-209564[colorbalanced].webp";
import nyar11_600 from "../../assets/images/gallery/600/2025nyar/juni1-209407[colorbalanced].webp";
import nyar12_600 from "../../assets/images/gallery/600/2025nyar/juni1-209385[colorbalanced].webp";
import nyar13_600 from "../../assets/images/gallery/600/2025nyar/juni1-209228[colorbalanced].webp";
import nyar14_600 from "../../assets/images/gallery/600/2025nyar/juni1-209106[colorbalanced].webp";

import nyar15_600 from "../../assets/images/gallery/600/2025nyar/hajofotok-200116[colorbalanced].webp";
import nyar16_600 from "../../assets/images/gallery/600/2025nyar/hajofotok-200141[colorbalanced].webp";
import nyar17_600 from "../../assets/images/gallery/600/2025nyar/hajofotok-200150[colorbalanced].webp";
import nyar18_600 from "../../assets/images/gallery/600/2025nyar/hajofotok-200261[colorbalanced].webp";
import nyar19_600 from "../../assets/images/gallery/600/2025nyar/hajofotok-200313[colorbalanced].webp";
import nyar20_600 from "../../assets/images/gallery/600/2025nyar/hajofotok-200442[colorbalanced].webp";
import nyar21_600 from "../../assets/images/gallery/600/2025nyar/hajofotok-209896[colorbalanced].webp";
import nyar22_600 from "../../assets/images/gallery/600/2025nyar/hajofotok-209901[colorbalanced].webp";

import nyar1_1366 from "../../assets/images/gallery/1366/2025nyar/majus31-07159[colorbalanced].webp";
import nyar2_1366 from "../../assets/images/gallery/1366/2025nyar/majus31-07002[colorbalanced].webp";
import nyar3_1366 from "../../assets/images/gallery/1366/2025nyar/majus31-07238[colorbalanced].webp";
import nyar4_1366 from "../../assets/images/gallery/1366/2025nyar/majus31-07423[colorbalanced].webp";
import nyar5_1366 from "../../assets/images/gallery/1366/2025nyar/majus31-07441[colorbalanced].webp";
import nyar6_1366 from "../../assets/images/gallery/1366/2025nyar/majus31-07727[colorbalanced].webp";
import nyar7_1366 from "../../assets/images/gallery/1366/2025nyar/juni1-209091[colorbalanced].webp";
import nyar8_1366 from "../../assets/images/gallery/1366/2025nyar/juni1-209182[colorbalanced].webp";
import nyar9_1366 from "../../assets/images/gallery/1366/2025nyar/juni1-209523[colorbalanced].webp";
import nyar10_1366 from "../../assets/images/gallery/1366/2025nyar/juni1-209564[colorbalanced].webp";
import nyar11_1366 from "../../assets/images/gallery/1366/2025nyar/juni1-209407[colorbalanced].webp";
import nyar12_1366 from "../../assets/images/gallery/1366/2025nyar/juni1-209385[colorbalanced].webp";
import nyar13_1366 from "../../assets/images/gallery/1366/2025nyar/juni1-209228[colorbalanced].webp";
import nyar14_1366 from "../../assets/images/gallery/1366/2025nyar/juni1-209106[colorbalanced].webp";

import nyar15_1366 from "../../assets/images/gallery/1366/2025nyar/hajofotok-200116[colorbalanced].webp";
import nyar16_1366 from "../../assets/images/gallery/1366/2025nyar/hajofotok-200141[colorbalanced].webp";
import nyar17_1366 from "../../assets/images/gallery/1366/2025nyar/hajofotok-200150[colorbalanced].webp";
import nyar18_1366 from "../../assets/images/gallery/1366/2025nyar/hajofotok-200261[colorbalanced].webp";
import nyar19_1366 from "../../assets/images/gallery/1366/2025nyar/hajofotok-200313[colorbalanced].webp";
import nyar20_1366 from "../../assets/images/gallery/1366/2025nyar/hajofotok-200442[colorbalanced].webp";
import nyar21_1366 from "../../assets/images/gallery/1366/2025nyar/hajofotok-209896[colorbalanced].webp";
import nyar22_1366 from "../../assets/images/gallery/1366/2025nyar/hajofotok-209901[colorbalanced].webp";

export let drinks = [
  { alt: "main1.gallery.alts.bar1", small: bar1_360, med: bar1_600, big: bar1_1366 },
  {
    small: historical11_360,
    med: historical11_600,
    big: historical11_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  { alt: "main1.gallery.alts.bar2", small: bar2_360, med: bar2_600, big: bar2_1366 },

  { alt: "main1.gallery.alts.bar7", small: bar7_360, med: bar7_600, big: bar7_1366 },
  { alt: "main1.gallery.alts.bar8", small: bar8_360, med: bar8_600, big: bar8_1366 },
  {
    small: historical9_360,
    med: historical9_600,
    big: historical9_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  { alt: "main1.gallery.alts.bar8", small: bar9_360, med: bar9_600, big: bar9_1366 },
  {
    small: historical7_360,
    med: historical7_600,
    big: historical7_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  { alt: "main1.gallery.alts.bar8", small: bar17_360, med: bar17_600, big: bar17_1366 },
  { alt: "main1.gallery.alts.bar8", small: bar18_360, med: bar18_600, big: bar18_1366 },
  { alt: "main1.gallery.alts.bar5", small: bar5_360, med: bar5_600, big: bar5_1366 },
];
export let home = [
  {
    small: elegant1_360,
    med: elegant1_600,
    big: elegant1_1366,
    alt: "main1.gallery.alts.elegant.1",
    ship: "cit",
    pos: "50% 100%",
  },
  {
    small: historical40_360,
    med: historical40_600,
    big: historical40_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "kisfaludy",
  },

  {
    small: nyar1_360,
    med: nyar1_600,
    big: nyar1_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant60_360,
    med: elegant60_600,
    big: elegant60_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant8_360,
    med: elegant8_600,
    big: elegant8_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant61_360,
    med: elegant61_600,
    big: elegant61_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: historical52_360,
    med: historical52_600,
    big: historical52_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical34_360,
    med: historical34_600,
    big: historical34_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
    pos: "50% 100%",
  },

  {
    small: elegant27_360,
    med: elegant27_600,
    big: elegant27_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: nyar15_360,
    med: nyar15_600,
    big: nyar15_1366,
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.1",
  },
  {
    small: nyar2_360,
    med: nyar2_600,
    big: nyar2_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: nyar16_360,
    med: nyar16_600,
    big: nyar16_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: nyar3_360,
    med: nyar3_600,
    big: nyar3_1366,
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.1",
  },
  {
    small: nyar4_360,
    med: nyar4_600,
    big: nyar4_1366,
    ship: "hableany",
    alt: "main1.gallery.alts.historical.1",
  },
  {
    small: nyar5_360,
    med: nyar5_600,
    big: nyar5_1366,
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.1",
  },
  {
    small: nyar19_360,
    med: nyar19_600,
    big: nyar19_1366,
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.1",
  },
  {
    small: nyar6_360,
    med: nyar6_600,
    big: nyar6_1366,
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.1",
  },
  {
    small: nyar7_360,
    med: nyar7_600,
    big: nyar7_1366,
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.1",
  },
  {
    small: nyar8_360,
    med: nyar8_600,
    big: nyar8_1366,
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.1",
  },
  {
    small: nyar16_360,
    med: nyar16_600,
    big: nyar16_1366,
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.1",
  },
  {
    small: nyar9_360,
    med: nyar9_600,
    big: nyar9_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: nyar10_360,
    med: nyar10_600,
    big: nyar10_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: nyar20_360,
    med: nyar20_600,
    big: nyar20_1366,
    ship: "kisfaludy",
    alt: "main1.gallery.alts.historical.1",
  },
  // {
  //   small: nyar11_360,
  //   med: nyar11_600,
  //   big: nyar11_1366,
  //   ship: "cit",
  //   alt: "main1.gallery.alts.elegant.1",
  // },
  // {
  //   small: nyar12_360,
  //   med: nyar12_600,
  //   big: nyar12_1366,
  //   ship: "cit",
  //   alt: "main1.gallery.alts.elegant.1",
  // },
  // {
  //   small: nyar13_360,
  //   med: nyar13_600,
  //   big: nyar13_1366,
  //   ship: "cit",
  //   alt: "main1.gallery.alts.elegant.1",
  // },
  // {
  //   small: nyar14_360,
  //   med: nyar14_600,
  //   big: nyar14_1366,
  //   ship: "cit",
  //   alt: "main1.gallery.alts.elegant.1",
  // },
];
export let elegant = [
  {
    small: elegant62_360,
    med: elegant62_600,
    big: elegant62_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant37_360,
    med: elegant37_600,
    big: elegant37_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant39_360,
    med: elegant39_600,
    big: elegant39_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: nyar3_360,
    med: nyar3_600,
    big: nyar3_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant45_360,
    med: elegant45_600,
    big: elegant45_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant1_360,
    med: elegant1_600,
    big: elegant1_1366,
    ship: "cit",
    pos: "50% 100%",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant2_360,
    med: elegant2_600,
    big: elegant2_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant22_360,
    med: elegant22_600,
    big: elegant22_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant57_360,
    med: elegant57_600,
    big: elegant57_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },

  {
    small: elegant3_360,
    med: elegant3_600,
    big: elegant3_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant13_360,
    med: elegant13_600,
    big: elegant13_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },

  {
    small: elegant6_360,
    med: elegant6_600,
    big: elegant6_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },

  {
    small: elegant47_360,
    med: elegant47_600,
    big: elegant47_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant8_360,
    med: elegant8_600,
    big: elegant8_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant17_360,
    med: elegant17_600,
    big: elegant17_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant9_360,
    med: elegant9_600,
    big: elegant9_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant10_360,
    med: elegant10_600,
    big: elegant10_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },

  {
    small: elegant14_360,
    med: elegant14_600,
    big: elegant14_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant15_360,
    med: elegant15_600,
    big: elegant15_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant12_360,
    med: elegant12_600,
    big: elegant12_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant59_360,
    med: elegant59_600,
    big: elegant59_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant16_360,
    med: elegant16_600,
    big: elegant16_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },

  {
    small: elegant20_360,
    med: elegant20_600,
    big: elegant20_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant21_360,
    med: elegant21_600,
    big: elegant21_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },

  {
    small: elegant23_360,
    med: elegant23_600,
    big: elegant23_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant29_360,
    med: elegant29_600,
    big: elegant29_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant24_360,
    med: elegant24_600,
    big: elegant24_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant25_360,
    med: elegant25_600,
    big: elegant25_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant26_360,
    med: elegant26_600,
    big: elegant26_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant27_360,
    med: elegant27_600,
    big: elegant27_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant4_360,
    med: elegant4_600,
    big: elegant4_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },

  {
    small: elegant5_360,
    med: elegant5_600,
    big: elegant5_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant18_360,
    med: elegant18_600,
    big: elegant18_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },

  {
    small: elegant30_360,
    med: elegant30_600,
    big: elegant30_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant31_360,
    med: elegant31_600,
    big: elegant31_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant32_360,
    med: elegant32_600,
    big: elegant32_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant33_360,
    med: elegant33_600,
    big: elegant33_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant34_360,
    med: elegant34_600,
    big: elegant34_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant35_360,
    med: elegant35_600,
    big: elegant35_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant36_360,
    med: elegant36_600,
    big: elegant36_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant7_360,
    med: elegant7_600,
    big: elegant7_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant38_360,
    med: elegant38_600,
    big: elegant38_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },

  {
    small: elegant40_360,
    med: elegant40_600,
    big: elegant40_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },

  {
    small: elegant41_360,
    med: elegant41_600,
    big: elegant41_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant42_360,
    med: elegant42_600,
    big: elegant42_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant11_360,
    med: elegant11_600,
    big: elegant11_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant19_360,
    med: elegant19_600,
    big: elegant19_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant43_360,
    med: elegant43_600,
    big: elegant43_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant44_360,
    med: elegant44_600,
    big: elegant44_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },

  {
    small: elegant46_360,
    med: elegant46_600,
    big: elegant46_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },

  {
    small: elegant48_360,
    med: elegant48_600,
    big: elegant48_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant49_360,
    med: elegant49_600,
    big: elegant49_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant50_360,
    med: elegant50_600,
    big: elegant50_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant28_360,
    med: elegant28_600,
    big: elegant28_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant58_360,
    med: elegant58_600,
    big: elegant58_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant51_360,
    med: elegant51_600,
    big: elegant51_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant52_360,
    med: elegant52_600,
    big: elegant52_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant53_360,
    med: elegant53_600,
    big: elegant53_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant54_360,
    med: elegant54_600,
    big: elegant54_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant55_360,
    med: elegant55_600,
    big: elegant55_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant56_360,
    med: elegant56_600,
    big: elegant56_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },

  {
    small: elegant60_360,
    med: elegant60_600,
    big: elegant60_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
  {
    small: elegant61_360,
    med: elegant61_600,
    big: elegant61_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },

  {
    small: elegant63_360,
    med: elegant63_600,
    big: elegant63_1366,
    ship: "cit",
    alt: "main1.gallery.alts.elegant.1",
  },
];
export let historical = [
  {
    small: historical42_360,
    med: historical42_600,
    big: historical42_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical14_360,
    med: historical14_600,
    big: historical14_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical7_360,
    med: historical7_600,
    big: historical7_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical51_360,
    med: historical51_600,
    big: historical51_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical48_360,
    med: historical48_600,
    big: historical48_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },

  {
    small: historical2_360,
    med: historical2_600,
    big: historical2_1366,
    alt: "main1.gallery.alts.historical.1",
    pos: "50% 80%",
    ship: "kisfaludy",
  },
  {
    small: historical3_360,
    med: historical3_600,
    big: historical3_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical4_360,
    med: historical4_600,
    big: historical4_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "kisfaludy",
    pos: "50% 100%",
  },
  {
    small: historical1_360,
    med: historical1_600,
    big: historical1_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "kisfaludy",
  },
  {
    small: historical5_360,
    med: historical5_600,
    big: historical5_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "kisfaludy",
  },
  {
    small: historical6_360,
    med: historical6_600,
    big: historical6_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical40_360,
    med: historical40_600,
    big: historical40_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "kisfaludy",
  },
  {
    small: historical17_360,
    med: historical17_600,
    big: historical17_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },

  {
    small: historical50_360,
    med: historical50_600,
    big: historical50_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical8_360,
    med: historical8_600,
    big: historical8_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical9_360,
    med: historical9_600,
    big: historical9_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },

  {
    small: historical23_360,
    med: historical23_600,
    big: historical23_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical11_360,
    med: historical11_600,
    big: historical11_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical12_360,
    med: historical12_600,
    big: historical12_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical41_360,
    med: historical41_600,
    big: historical41_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "kisfaludy",
  },
  {
    small: historical47_360,
    med: historical47_600,
    big: historical47_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical13_360,
    med: historical13_600,
    big: historical13_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },

  {
    small: historical16_360,
    med: historical16_600,
    big: historical16_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },

  {
    small: historical18_360,
    med: historical18_600,
    big: historical18_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical43_360,
    med: historical43_600,
    big: historical43_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical44_360,
    med: historical44_600,
    big: historical44_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical45_360,
    med: historical45_600,
    big: historical45_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical46_360,
    med: historical46_600,
    big: historical46_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },

  {
    small: historical49_360,
    med: historical49_600,
    big: historical49_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical19_360,
    med: historical19_600,
    big: historical19_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical20_360,
    med: historical20_600,
    big: historical20_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical21_360,
    med: historical21_600,
    big: historical21_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical22_360,
    med: historical22_600,
    big: historical22_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },

  {
    small: historical24_360,
    med: historical24_600,
    big: historical24_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical25_360,
    med: historical25_600,
    big: historical25_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical26_360,
    med: historical26_600,
    big: historical26_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical36_360,
    med: historical36_600,
    big: historical36_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "kisfaludy",
  },
  {
    small: historical27_360,
    med: historical27_600,
    big: historical27_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical15_360,
    med: historical15_600,
    big: historical15_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical28_360,
    med: historical28_600,
    big: historical28_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical29_360,
    med: historical29_600,
    big: historical29_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical30_360,
    med: historical30_600,
    big: historical30_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical31_360,
    med: historical31_600,
    big: historical31_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical32_360,
    med: historical32_600,
    big: historical32_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical10_360,
    med: historical10_600,
    big: historical10_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical33_360,
    med: historical33_600,
    big: historical33_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "hableany",
  },
  {
    small: historical34_360,
    med: historical34_600,
    big: historical34_1366,
    alt: "main1.gallery.alts.historical.1",
    pos: "50% 100%",
    ship: "hableany",
  },
  {
    small: historical35_360,
    med: historical35_600,
    big: historical35_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "kisfaludy",
  },

  {
    small: historical37_360,
    med: historical37_600,
    big: historical37_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "kisfaludy",
  },
  {
    small: historical38_360,
    med: historical38_600,
    big: historical38_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "kisfaludy",
  },
  {
    small: historical39_360,
    med: historical39_600,
    big: historical39_1366,
    alt: "main1.gallery.alts.historical.1",
    ship: "kisfaludy",
  },
];
export let gallery = [elegant[0], historical[0]];
function Gallery(props) {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    let lightbox = new PhotoSwipeLightbox({
      gallery: "#gallery",
      children: "b",
      showHideAnimationType: "zoom",
      pswpModule: () => import("photoswipe"),
    });
    lightbox.init();

    return () => {
      lightbox.destroy();
      lightbox = null;
    };
  }, []);
  const { t } = useTranslation();

  const mappedDrinks = drinks.map((e, i) => {
    return (
      <SwiperSlide key={i}>
        <img
          loading="lazy"
          src={width <= 380 ? e.small : width <= 1000 ? e.med : e.big}
          alt={t([e.alt, "main1.gallery.alts.fallback"])}
          className="img-container-drinks"
          style={{
            objectFit: "cover",
            height: "100%",
            width: "100%",
            minHeight: "100%",
            minWidth: "100%",
          }}
        />
      </SwiperSlide>
    );
  });

  useEffect(() => {
    let isMounted = true;
    window.addEventListener("resize", () => {
      if (isMounted) setWidth(window.innerWidth);
    });

    return () => {
      isMounted = false;
      window.removeEventListener("resize", () => setWidth(window.innerWidth));
    };
  }, []);
  const getImgs = (path) => {
    const elements = document.querySelectorAll(`.${path} .swiper-slide-visible`);
    if (elements.length > 0 && elements[elements.length - 1].nextSibling) {
      elements.forEach((e) => e.children[0].setAttribute("loading", "eager"));
      elements.forEach((e) => {
        if (e.nextSibling) {
          e.nextSibling.children[0].setAttribute("loading", "eager");
        }
      });
      // elements[elements.length - 1].nextSibling.children[0].setAttribute("loading", "eager");
    }
  };
  const { ref, inView, entry } = useInView({
    /* Optional options */
    threshold: 0,
    triggerOnce: true,
  });
  return (
    <section ref={ref} id={"bar-gallery"}>
      <div className="drinks-gallery-wrap">
        <Swiper
          watchSlidesProgress
          onSlideChange={() => getImgs("drinks-gallery-wrap")}
          modules={[Navigation, Pagination, Autoplay]}
          slidesPerView={1}
          autoplay={inView ? { delay: 6000, disableOnInteraction: true } : {}}
          speed={600}
          navigation
          centeredSlides
          loop>
          {mappedDrinks}
        </Swiper>
      </div>
    </section>
  );
}

export default Gallery;
